import * as React from 'react';
import classnames from 'classnames';
import { throttle } from 'lodash';
import { currentYPosition } from '@/utils/scroll';

import * as styles from './styles.module.css';

interface IScrollWrap {
  // target: () => HTMLElement;
  showHeight?: number; //当页面滚动高度超过此值显示
  isHalfScreen?: boolean;
  hideTarget?: string; //当页面滚动高度超过此值 隐藏
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}

const ScrollWrap: React.FC<IScrollWrap> = ({
  showHeight,
  isHalfScreen = false,
  hideTarget = '',
  className,
  children,
  onClick,
}) => {
  const [isVisibled, setIsVisibled] = React.useState(false);
  const hideTargetHeight = React.useRef(0);

  React.useLayoutEffect(() => {
    hideTargetHeight.current =
      (!!hideTarget && document.getElementById(hideTarget)?.offsetTop - window.innerHeight) || 0;
  });

  React.useEffect(() => {
    const handleScroll = throttle(() => {
      const scrollY = currentYPosition();

      const judgeRollingDistance = (): boolean => {
        const height = showHeight ?? window.innerHeight;
        const isShow = scrollY >= (isHalfScreen ? height / 2 : height);
        if (!!hideTarget) return isShow && scrollY <= hideTargetHeight.current;
        return isShow;
      };

      setIsVisibled(judgeRollingDistance());
    }, 300);

    document.addEventListener('scroll', handleScroll);

    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-visible={isVisibled} className={classnames(styles.scroll_wrap, className)} onClick={onClick}>
      {children}
    </div>
  );
};

export default ScrollWrap;
